import { Stripe, StripeCardNumberElement } from '@stripe/stripe-js';
import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';
import { ProviderPackageId } from 'types/planUtils';

import { OnboardingSasuOffersQuery } from '../graphql/queries/onboardingSasuOffers.gql';
import { StepsPricingPlansDataQuery } from '../graphql/queries/stepsPricingPlansData.gql';

export type OnboardingPackageItem = Omit<
  OnboardingSasuOffersQuery['viewer']['company']['onboardingPackages'][number],
  'providerPackageId'
> & {
  providerPackageId: ProviderPackageId;
};

export type PricingPlansModuleData = StepsPricingPlansDataQuery & {
  stripe: Stripe;
  isMobile: boolean;
};

export type Context = {
  getModuleData: () => PricingPlansModuleData;
  selectedPlan: Pick<
    OnboardingPackageItem['plan'],
    'brandName' | 'features' | 'providerPlanId'
  > | null;
  selectedPackage: Pick<OnboardingPackageItem, 'providerPackageId'> | null;
};

const initialContext: Context = {
  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
  selectedPackage: null,
  selectedPlan: null,
};

const creators = {
  events: {
    ...baseEvents,
    ABORT: () => ({}),
    PAY: (data: { cardElement: StripeCardNumberElement }) => ({ data }),
    SAVE_SELECTED_PACKAGE: (data: OnboardingPackageItem) => ({ data }),
    SHOW_DETAILS: () => ({}),
  },
};

const model = createModel(initialContext, creators);

export type Model = typeof model;
export default model;
